export const dashboardI18n = {
  en: {
    BoardTitle: {
      first: 'YOUR',
      second: 'ASHRAM',
      third: 'VISIT',
    },
    visitorDashboard: 'VISITOR DASHBOARD',
    activeLabel: 'Active',
    rightNow: 'RIGHT NOW',
    quietHours: 'QUIET HOURS',
    nextUp: 'NEXT UP',
    startingFrom: 'Starting from',
    startingPoint: 'Starting point',
    fromLabel: 'From',
    datVisitorPass: 'Day Visitor Pass',
    tapToHide: 'Tap to hide',
    tapToShow: 'Tap to show QR code at gate',
    getMyQR: 'Get my QR',
    getMyQRSubtitle: 'Register to get your visitor pass',
    getPassFirst: 'Please get your pass first',
    quickLinks: [
      { id: 'meals', label: 'Meals' },
      { id: 'buggy', label: 'Buggy' },
      { id: 'explore', label: 'Explore' },
      { id: 'nearby', label: 'Nearby' },
      { id: 'tours', label: 'Tours' },
      { id: 'plan', label: 'Plan your Visit' },
    ],
    quotes: {
      text: 'Play, laugh, and sleep like a child. Let worldly accomplishments not be at the cost of your inherent innocence.',
      source: 'Pujya Gurudevshri Rakeshji',
    },
    planYourVisit: {
      first: 'PLAN YOUR',
      second: 'VISIT',
    },
    whenAreYouArriving: 'WHEN ARE YOU ARRIVING?',
    selectedLabel: 'Selected',
    howLong: 'FOR HOW LONG?',
    showThisAtTheGate: 'Show this at the gate',
    swipeToSwitchPass: 'Swipe to switch pass',
    createMyTour: 'CREATE MY TOUR',
    yourTour: 'YOUR TOUR',
    yourRecommendedTour: 'Your Recommended Tour',
    overnightLabel: 'OVERNIGHT',
    extraSuggestionTitle: 'EXTEND YOUR VISIT',
    waitLabel: 'Wait',
    checkinFrom: 'Check-in from',
    checkoutBy: 'Check-out by',
    thisEvening: 'This evening',
    tomorrowMorning: 'Tomorrow morning',
    bookStayTitle: 'Book your stay at the ashram',
    bookStayCta: 'BOOK STAY',
    planAnotherVisit: 'Plan another visit',
    downloadPdf: 'Download PDF',
    printPdf: 'Print',
    welcomeCentre: 'Welcome Centre',
    welcomeCentreOrientation: 'Welcome Centre Orientation',
    atWelcomeCentre: 'At Welcome Centre',
    ashramTour: 'Ashram Tour',
    partOfAshramTour: (desc) => `Part of Ashram Tour - ${desc}`,
    walkOrBuggy: (min) => `${min} mins walk or buggy`,
    diningHall: 'Dining Hall / Cafeteria',
    duringMealTime: 'During meal time',
    seeLabel: 'See:',
    aartiAtJinmandir: (time) => `Aarti at Jinmandir · ${time}`,
    tourLabel: 'Tour',
    guidedToursTitle: 'GUIDED ASHRAM TOURS',
    guidedToursSubtitle: '45 mins from Welcome Centre',
    guidedTourArrivalNote: 'Please arrive 15 minutes before your guided tour. If your tour starts at 9:00 am, please arrive by 8:45 am for orientation.',
    duration45: '45 mins',
    stopsLabel: 'STOPS',
    freeTimeRemaining: (min) => `~${min} mins free time remaining`,
    placesExploreInfo: [
      { title: 'Ashram Schedule', subtitle: 'Daily timings', dark: true, icon: 'calendar', href: 'https://www.srmd.org/AshramDailySchedule/?type=V' },
      { title: 'Helpful Info', subtitle: 'Useful links', dark: false, icon: 'info' },
      { title: 'Ashram Culture', subtitle: 'Values & way of life', dark: false, icon: 'people', id: 'ashramCulture' },
    ],
    relatedInfo: {
      title: 'Help & Information',
      loading: 'Loading…',
      error: 'Unable to load information right now.',
      searchPlaceholder: 'Search',
      close: 'Close',
    },
    scheduleLabels: {
      Breakfast: 'Breakfast',
      'Ashram Tour': 'Ashram Tour',
      Pravachan: 'Pravachan',
      Lunch: 'Lunch',
      Satsang: 'Satsang',
      Aarti: 'Aarti',
      Dinner: 'Dinner',
    },
    eveningYogaText: 'Yoga 5:15 PM – 5:45 PM · Yajnasthal',
    aartiJinmandirTime: '7:30 PM – 8:00 PM',
    mealDayPass: { key: 'dayPass', name: 'Day Pass', desc: 'All meals (Breakfast, Lunch, Dinner)', price: 330 },
    foodAndDining: 'FOOD & DINING',
    cafeteriaAvailabilityNote: 'The cafeteria is also available for visitors and remains open from 8 am to sunset time.',
   
    gettingAround: 'getting around',
    nextBuggy: 'Buggy from Welcome Centre',
    buyMealCoupon: 'Buy Meal Coupon',
    clickToBuyMeal: 'Click to buy meal',
    buggyFinder: 'Buggy Finder',
    buyEpass: 'Buy Buggy Coupon',
    buyMealPass: 'Buy Meal Pass',
    whereAreYouNow: 'Where are you right now?',
    upcomingTimings: 'UPCOMING TIMINGS',
    viewFullSchedule: 'VIEW FULL SCHEDULE',
    viewRoute: 'VIEW ROUTE',
    routeStopsLabel: 'ROUTE STOPS',
    fullScheduleLabel: 'UPCOMING RIDES',
    rideNoLabel: 'Ride No.',
    noBuggyRoutes: 'No buggy routes found for this stop.',
    nearbyPlacesTitle: "Nearby Places You Shouldn't Miss",
    fullScheduleTitle: 'Full Schedule',
    morning: 'Morning',
    afternoon: 'Afternoon',
    evening: 'Evening',
    noScheduleAvailable: 'No schedule available.',
    walkingDistancesTitle: 'Walking Distances',
    toLabel: 'TO',
    distanceLabel: 'DISTANCE',
    timeLabel: 'TIME',
    minsShort: 'mins',
    noWalkingData: 'No walking distances available.',
    venueLabel: 'Venue',
    myCoupen: 'My Transactions',
    every15Minutes: 'EVERY 15 MINS',
    buggyStops: ['Welcome Centre', 'Yajnasthal - 2', 'Raj Darbar', 'Lower Dining', 'Jinmandir', 'Community Garden', 'Sadhana - Aradhana', 'Upper Dining', 'Shraddha', 'Yajnasthal - 3', 'Welcome Centre'],
    buyBuggyCoupon: 'Buy Buggy Coupon',
    routeMap: 'Route Map',
    spaces: [
      { name: 'Jinmandir', img: 'https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2022/02/JM-Pg_Top-Banner-2.jpg?x83243', desc: 'Sacred Jain temple', featured: true },
      { name: 'Raj Sabhagruh', img: 'https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2023/12/RS_Nightime.jpg', desc: 'Self-study & reflection' },
      { name: 'Raj Darbar', img: 'https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2022/12/Raj_Darbar-1-new.png', desc: 'Grand court' },
      { name: 'Meditation Hall', img: 'https://images.unsplash.com/photo-1545389336-cf090694435e?w=400&q=80', desc: 'Silent meditation' },
      { name: 'Library', img: 'https://images.unsplash.com/photo-1526243741027-444d633d7365?w=300&q=80', desc: 'Books & quiet study' },
      { name: 'Meditation Garden', img: 'https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?w=400&q=80', desc: 'Nature walks' },
      { name: 'Divine Shop', img: 'https://images.unsplash.com/photo-1526243741027-444d633d7365?w=300&q=80', desc: 'Literature & gifts' },
    ],
    placesNearby: [
      { name: 'Raj Uphaar', img: 'https://upload.wikimedia.org/wikipedia/commons/9/99/Shrimad_Rajchandra_Mission_Dharampur_Yatra.jpg' },
      { name: 'Shrimad Rajchandra Jivamaitridham', img: 'https://upload.wikimedia.org/wikipedia/commons/3/3c/Shrimad_Rajchandra_Mission_Dharampur_Ashram.jpg' },
      { name: 'Lady Wilson Museum', img: 'https://upload.wikimedia.org/wikipedia/commons/6/6f/Lakshmi_Temple_Dharampur.jpg' },
      { name: 'Ranchhodbhai House', img: 'https://upload.wikimedia.org/wikipedia/commons/6/69/View_of_dharampur.jpg' },
    ],
    RECOMMENDED: 'RECOMMENDED',
    yourCompanion: 'A Free Mobile App for Inner Growth and Daily Spiritual Practice',
    exploreSpace: {
      first: 'EXPLORE',
      second: 'ASHRAM',
    },
    nearbySpace: {
      first: 'PLACES TO EXPLORE',
      second: 'NEARBY',
    },
    selfConnect: 'SELF CONNECT',
    appStore: 'App Store',
    playStore: 'Play Store',
    mealCouponTitle: 'MEAL COUPON',
    mealCouponDesc: 'Purchase coupons for meals at the Ashram.',
    forDayVisitors: 'For Day Visitors',
    orBuyIndividualMeals: 'Or buy individual meals',
    subtotal: 'Subtotal',
    payOnline: 'Pay Online',
    processing: 'Processing…',
    mealCouponNote: 'Please Note: Meal coupons can also be purchased at the Registration Office.',
    noMealsAvailable: 'No Meals Available At This Time',
    transactionHistoryTitle: 'TRANSACTION HISTORY',
    transactionHistorySubtitle: 'Your meal and buggy coupon purchases.',
    back: 'Back',
    filterAll: 'All',
    filterMeals: 'Meals',
    filterBuggy: 'Buggy',
    loadingTransactions: 'Loading transactions…',
    noTransactions: 'No transactions in this category.',
    amountPaid: 'Amount Paid',
    mealCouponsLabel: 'MEAL COUPONS',
    buggyCouponsLabel: 'BUGGY COUPONS',
    scanningHistoryTitle: 'SCANNING HISTORY',
    loadingScans: 'Loading scans…',
    noScanningHistory: 'No scanning history found.',
    buggyCouponTitle: 'BUGGY COUPON',
    buggyCouponDesc: 'As the Ashram is spread across a vast land of 223 acres, it is recommended that you purchase buggy passes for easy commute around the Ashram.',
    dailyPass: 'DAILY PASS',
    buggyCouponNote: 'Please note: Buggy passes can also be purchased at the Registration Office.',
    overnightLabelKey: 'Overnight',
    plannerActivities: {
      jinmandir: { name: 'Jinmandir', desc: 'Sacred Jain temple', whatToSee: 'Shri Mahavir Praasad & Gurumandir' },
      swadhyay: { name: 'Raj Sabhagruh', desc: 'Self-study hall', whatToSee: 'Swadhyay Hall, Meditation Hall & Library' },
      rajdarbar: { name: 'Raj Darbar', desc: 'Grand ceremonial court' },
      library: { name: 'Library', desc: 'Books & quiet study' },
      meditation: { name: 'Meditation Hall', desc: 'Silent meditation space' },
      gardens: { name: 'Meditation Garden', desc: 'Peaceful walking paths' },
      cafeteria: { name: 'Cafeteria', desc: 'Light meals & refreshments' },
      bookstore: { name: 'Divine Shop', desc: 'Literature & souvenirs' },
      aarti: { name: 'Aarti Darshan', desc: 'Sacred prayer ceremony' },
    },
    freeTimeNow: 'Free time',
    freeTimeBadge: 'Free Time',
    nearByPlaceBadge: 'Near By Place',
    mealBadge: 'Meal',
  },
  gu: {
    freeTimeNow: 'ફરવા લાયક',
    freeTimeBadge: 'ખાલી સમય મા ફરવા લાયક',
    nearByPlaceBadge: 'નજીકમાં ફરવા લાયક જગ્યા',
    mealBadge: 'ભોજન',
    BoardTitle: {
      first: 'આશ્રમની',
      second: 'તમારી',
      third: 'મુલાકાત',
    },
    visitorDashboard: 'વિઝિટર ડેશબોર્ડ',
    activeLabel: 'સક્રિય',
    rightNow: 'અત્યારે',
    quietHours: 'શાંતિના સમય',
    nextUp: 'પછી',
    startingFrom: 'શરૂઆત',
    startingPoint: 'શરૂઆતનું સ્થળ',
    fromLabel: 'થી',
    datVisitorPass: 'દિવસ મુલાકાત પાસ',
    tapToHide: 'બંધ કરવા માટે ટૅપ કરો',
    tapToShow: 'ગેટ પર QR કોડ બતાવવા માટે ટૅપ કરો',
    getMyQR: 'મારો QR મેળવો',
    getMyQRSubtitle: 'તમારો મુલાકાત પાસ મેળવવા માટે નોંધણી કરો',
    getPassFirst: 'કૃપા કરીને પહેલા તમારો પાસ મેળવો',
    quickLinks: [
      { id: 'meals', label: 'ભોજન' },
      { id: 'buggy', label: 'બગ્ગી' },
      { id: 'explore', label: 'વધુ જાણો' },
      { id: 'nearby', label: 'નજીકની જગ્યાઓ' },
      { id: 'tours', label: 'પ્રવાસ' },
      { id: 'plan', label: 'તમારી ટૂરનું આયોજન કરો' },
    ],
    quotes: {
      text: 'બાળકની જેમ રમો, હસો અને સૂઈ જાઓ. દુન્યવી સિદ્ધિઓને તમારી સહજ નિર્દોષતાની કિંમતે ન થવા દો.',
      source: 'પૂજ્ય ગુરુદેવશ્રી રાકેશજી',
    },
    planYourVisit: {
      first: 'તમારી મુલાકાતનું',
      second: 'આયોજન કરો',
    },
    whenAreYouArriving: 'તમે ક્યારે પહોંચશો?',
    selectedLabel: 'પસંદગી',
    howLong: 'કેટલો સમય?',
    showThisAtTheGate: 'આ QR ને પ્રવેશ વખતે ગેટ પર બતાવો',
    swipeToSwitchPass: 'પાસ સ્વિચ કરવા માટે સ્વાઇપ કરો',
    createMyTour: 'ટૂરનું આયોજન કરો',
    yourTour: 'તમારો પ્રવાસ',
    yourRecommendedTour: 'ટૂર માટેની ભલામણ',
    overnightLabel: 'રાત્રી રોકાણ',
    extraSuggestionTitle: 'મુલાકાત લંબાવો',
    waitLabel: 'પ્રતીક્ષા',
    checkinFrom: 'ચેક-ઇન',
    checkoutBy: 'ચેક-આઉટ',
    thisEvening: 'આ સાંજ',
    tomorrowMorning: 'કાલે સવારે',
    bookStayTitle: 'આશ્રમમાં રહેવા માટે  બુકિંગ કરો',
    bookStayCta: 'બુક કરો',
    planAnotherVisit: 'ફરીથી આયોજન કરો',
    downloadPdf: 'PDF ડાઉનલોડ કરો',
    printPdf: 'પ્રિન્ટ',
    welcomeCentre: 'સ્વાગત કેન્દ્ર',
    welcomeCentreOrientation: 'સ્વાગત કેન્દ્ર પરિચય',
    atWelcomeCentre: 'સ્વાગત કેન્દ્રમાં',
    ashramTour: 'આશ્રમ પ્રવાસ',
    partOfAshramTour: (desc) => `આશ્રમ પ્રવાસનો ભાગ - ${desc}`,
    walkOrBuggy: (min) => `${min} મિનિટ ચાલવું અથવા બગ્ગી`,
    diningHall: 'ડાઇનિંગ હોલ / કેફેટેરિયા',
    duringMealTime: 'ભોજન સમયે',
    seeLabel: 'જુઓ:',
    aartiAtJinmandir: (time) => `જિનમંદિરમાં આરતી · ${time}`,
    tourLabel: 'ટુર',
    guidedToursTitle: 'ગાઈડ સાથે આશ્રમ દર્શન',
    guidedToursSubtitle: 'સ્વાગત કેન્દ્રથી 45 મિનિટ',
    guidedTourArrivalNote: 'કૃપા કરીને તમારી ગાઈડ સાથેની ટૂર શરૂ થવાના 15 મિનિટ પહેલાં પહોંચી જાઓ. જો તમારી ટૂર 9:00 AM વાગ્યે શરૂ થતી હોય, તો ઓરિએન્ટેશન માટે 8:45 AM સુધીમાં પહોંચી જાઓ.',
    duration45: '45 મિનિટ',
    stopsLabel: 'સ્ટોપ્સ',
    freeTimeRemaining: (min) => `~${min} મિનિટ ફ્રી સમય બચ્યો`,
    placesExploreInfo: [
      { title: 'આશ્રમનું સમયપત્રક', subtitle: 'દૈનિક સમય', dark: true, icon: 'calendar', href: 'https://www.srmd.org/AshramDailySchedule/?type=V' },
      { title: 'ઉપયોગી માહિતી', subtitle: 'ઉપયોગી લિંક્સ', dark: false, icon: 'info' },
      { title: 'આશ્રમ સંસ્કૃતિ', subtitle: 'મૂલ્યો અને જીવનશૈલી', dark: false, icon: 'people', href: '/ashram-culture' },
      
    ],
    relatedInfo: {
      title: 'મદદ અને માહિતી',
      loading: 'લોડ થઈ રહ્યું છે…',
      error: 'હાલ માહિતી લોડ થઈ શકતી નથી.',
      searchPlaceholder: 'શોધો',
      close: 'બંધ કરો',
    },
    scheduleLabels: {
      Breakfast: 'નાસ્તો',
      'Ashram Tour': 'આશ્રમ પ્રવાસ',
      Pravachan: 'પ્રવચન',
      Lunch: 'બપોરનું ભોજન',
      Satsang: 'સત્સંગ',
      Aarti: 'આરતી',
      Dinner: 'સાંજનું ભોજન',
    },
    eveningYogaText: 'યોગ 5:15 PM – 5:45 PM · યજ્ઞસ્થલ',
    aartiJinmandirTime: '7:30 PM – 8:00 PM',
    mealDayPass: { key: 'dayPass', name: 'ડે પાસ', desc: 'બધા ભોજન (નાસ્તો, બપોર, સાંજ)', price: 330 },
    foodAndDining: 'ભોજન',
    cafeteriaAvailabilityNote: 'કેફેટેરિયા પણ મુલાકાતીઓ માટે ઉપલબ્ધ છે અને સવારે 8 થી સૂર્યાસ્ત સુધી ખુલ્લું રહે છે.',
    gettingAround: 'સુવિધાપૂર્વકની યાત્રા માટે',
    nextBuggy: 'વેલકમ સેન્ટર થી બગ્ગી',
    buyMealCoupon: 'ભોજન કૂપન ખરીદો',
    clickToBuyMeal: 'ભોજન ખરીદવા ક્લિક કરો',
    buggyFinder: 'બગ્ગી ફાઇન્ડર',
    buyEpass: 'બગ્ગી કૂપન ખરીદો',
    buyMealPass: 'ભોજન પાસ ખરીદો',
    whereAreYouNow: 'તમે અત્યારે ક્યાં છો?',
    upcomingTimings: 'આગામી સમય',
    viewFullSchedule: 'સંપૂર્ણ સમયપત્રક જુઓ',
    viewRoute: 'રૂટ જુઓ',
    routeStopsLabel: 'રૂટ સ્ટોપ્સ',
    fullScheduleLabel: 'આગામી રાઇડ્સ',
    rideNoLabel: 'રાઇડ નં.',
    noBuggyRoutes: 'આ સ્ટોપ માટે કોઈ બગ્ગી રૂટ મળ્યો નથી.',
    nearbyPlacesTitle: 'નજીકનાં અવશ્ય જોવાલાયક સ્થળો',
    fullScheduleTitle: 'સંપૂર્ણ સમયપત્રક',
    morning: 'સવાર',
    afternoon: 'બપોર',
    evening: 'સાંજ',
    noScheduleAvailable: 'કોઈ સમયપત્રક ઉપલબ્ધ નથી.',
    walkingDistancesTitle: 'ચાલવાનું અંતર',
    toLabel: 'સુધી',
    distanceLabel: 'અંતર',
    timeLabel: 'સમય',
    minsShort: 'મિનિટ',
    noWalkingData: 'કોઈ ચાલવાનું અંતર ઉપલબ્ધ નથી.',
    venueLabel: 'સ્થળ',
    myCoupen: 'મારા ટ્રાન્ઝેક્શન્સ',
    every15Minutes: 'દર ૧૫ મિનિટે',
    buggyStops: [
      'વેલકમ સેન્ટર',
      'યજ્ઞસ્થળ - ૨',
      'રાજ દરબાર',
      'લોઅર ડાઇનિંગ',
      'જિનમંદિર',
      'કોમ્યુનિટી ગાર્ડન',
      'સાધના - આરાધના',
      'અપર ડાઇનિંગ',
      'શ્રદ્ધા',
      'યજ્ઞસ્થળ - ૩',
      'વેલકમ સેન્ટર'
    ],
    buyBuggyCoupon: 'બગ્ગી કૂપન ખરીદો',
    routeMap: 'રૂટ મેપ',
    spaces: [
      { name: 'જિનમંદિર', img: 'https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2022/02/JM-Pg_Top-Banner-2.jpg?x83243', desc: 'પવિત્ર જૈન મંદિર', featured: true },
      { name: 'રાજ સભાગૃહ', img: 'https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2023/12/RS_Nightime.jpg', desc: 'સ્વ-અભ્યાસ અને મનન' },
      { name: 'રાજ દરબાર', img: 'https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2022/12/Raj_Darbar-1-new.png', desc: 'ભવ્ય દરબાર' },
      { name: 'ધ્યાન હોલ', img: 'https://images.unsplash.com/photo-1545389336-cf090694435e?w=400&q=80', desc: 'શાંત ધ્યાન' },
      { name: 'લાઇબ્રેરી', img: 'https://images.unsplash.com/photo-1526243741027-444d633d7365?w=300&q=80', desc: 'પુસ્તકો અને શાંતિપૂર્ણ અભ્યાસ' },
      { name: 'ધ્યાન બગીચો', img: 'https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?w=400&q=80', desc: 'પ્રકૃતિમાં ફરવું' },
      { name: 'દિવ્ય દુકાન', img: 'https://images.unsplash.com/photo-1526243741027-444d633d7365?w=300&q=80', desc: 'સાહિત્ય અને ભેટો' },
    ],
    placesNearby: [
      { name: 'રાજ ઉપહાર', img: 'https://upload.wikimedia.org/wikipedia/commons/9/99/Shrimad_Rajchandra_Mission_Dharampur_Yatra.jpg' },
      { name: 'શ્રીમદ રાજચંદ્ર જીવમૈત્રીધામ', img: 'https://upload.wikimedia.org/wikipedia/commons/3/3c/Shrimad_Rajchandra_Mission_Dharampur_Ashram.jpg' },
      { name: 'લેડી વિલ્સન મ્યુઝિયમ', img: 'https://upload.wikimedia.org/wikipedia/commons/6/6f/Lakshmi_Temple_Dharampur.jpg' },
      { name: 'રાંચોડભાઈ હાઉસ', img: 'https://upload.wikimedia.org/wikipedia/commons/6/69/View_of_dharampur.jpg' },
    ],
    RECOMMENDED: 'અમારું સૂચન',
    yourCompanion: 'આંતરિક વિકાસ અને દૈનિક આધ્યાત્મિક અભ્યાસ માટેનું નિઃશુલ્ક મોબાઇલ એપ',
    exploreSpace: {
      first: 'જોવાલાયક',
      second: 'સ્થળો',
    },
    nearbySpace: {
      first: 'નજીકના જોવાલાયક ',
      second: 'સ્થળો',
    },
    selfConnect: 'સેલ્ફ કનેક્ટ',
    appStore: 'એપ સ્ટોર',
    playStore: 'પ્લે સ્ટોર',
    mealCouponTitle: 'ભોજન કૂપન',
    mealCouponDesc: 'આશ્રમમાં ભોજન માટે કૂપન ખરીદો.',
    forDayVisitors: 'આખા દિવસ માટે',
    orBuyIndividualMeals: 'અથવા અલગ ભોજન ખરીદો',
    subtotal: 'સબટોટલ',
    payOnline: 'ઓનલાઇન ભુગતાન',
    processing: 'આયોજન બની રહ્યું છે…',
    mealCouponNote: 'નોંધ: તમે ભોજન પાસ રજીસ્ટ્રેશન ઓફિસમાંથી પણ ખરીદી શકો છો.',
    noMealsAvailable: 'આ સમયે ભોજન ઉપલબ્ધ નથી',
    transactionHistoryTitle: 'ટ્રાન્ઝેક્શન હિસ્ટ્રી',
    transactionHistorySubtitle: 'તમારા ભોજન અને બગ્ગી કૂપન ખરીદ.',
    back: 'પાછા',
    filterAll: 'બધું',
    filterMeals: 'ભોજન',
    filterBuggy: 'બગ્ગી',
    loadingTransactions: 'ટ્રાન્ઝેક્શન લોડ થઈ રહ્યું છે…',
    noTransactions: 'આ કેટેગરીમાં કોઈ ટ્રાન્ઝેક્શન નથી.',
    amountPaid: 'ચૂકવેલ રકમ',
    mealCouponsLabel: 'ભોજન કૂપન',
    buggyCouponsLabel: 'બગ્ગી કૂપન',
    scanningHistoryTitle: 'સ્કેનિંગ હિસ્ટ્રી',
    loadingScans: 'સ્કેન લોડ થઈ રહ્યા છે…',
    noScanningHistory: 'સ્કેનિંગ હિસ્ટ્રી મળી નથી.',
    buggyCouponTitle: 'બગ્ગી કૂપન',
    buggyCouponDesc: 'આશ્રમ 223 એકરના વિસ્તાર પર ફેલાયેલ છે, તેથી સરળ મુસાફરી માટે બગ્ગી પાસ ખરીદવાની ભલામણ છે.',
    dailyPass: 'દૈનિક પાસ',
    buggyCouponNote: 'નોંધ કરો: તમે બગ્ગી પાસ રજીસ્ટ્રેશન ઓફિસમાંથી   પણ ખરીદી શકો છો.',
    overnightLabelKey: 'રાત્રી રોકાણ',
    plannerActivities: {
      jinmandir: { name: 'જિનમંદિર', desc: 'પવિત્ર જૈન મંદિર', whatToSee: 'શ્રી મહાવીર પ્રસાદ અને ગુરુમંદિર' },
      swadhyay: { name: 'રાજ સભાગૃહ', desc: 'સ્વ-અભ્યાસ હોલ', whatToSee: 'સ્વાધ્યાય હોલ, ધ્યાન હોલ અને લાઇબ્રેરી' },
      rajdarbar: { name: 'રાજ દરબાર', desc: 'ભવ્ય દરબાર' },
      library: { name: 'લાઇબ્રેરી', desc: 'પુસ્તકો અને શાંતિપૂર્ણ અભ્યાસ' },
      meditation: { name: 'ધ્યાન હોલ', desc: 'શાંત ધ્યાન જગ્યા' },
      gardens: { name: 'ધ્યાન બગીચો', desc: 'શાંતિપૂર્ણ પાથ' },
      cafeteria: { name: 'કેફેટેરિયા', desc: 'હળવા ભોજન અને રિફ્રેશમેન્ટ' },
      bookstore: { name: 'દિવ્ય દુકાન', desc: 'સાહિત્ય અને સ્મૃતિચિહ્નો' },
      aarti: { name: 'આરતી દર્શન', desc: 'પવિત્ર પ્રાર્થના વિધિ' },
    },
  },
  hi: {
    freeTimeNow: 'घूमने लायक',
    freeTimeBadge: 'खाली समय में घूमने लायक',
    nearByPlaceBadge: 'नज़दीक में घूमने लायक जगह',
    mealBadge: 'भोजन',
    BoardTitle: {
      first: 'आपका',
      second: 'आश्रम',
      third: 'विज़िट',
    },
    visitorDashboard: 'विज़िटर डैशबोर्ड',
    activeLabel: 'सक्रिय',
    rightNow: 'अभी',
    quietHours: 'शांत समय',
    nextUp: 'आगे',
    startingFrom: 'शुरू',
    startingPoint: 'प्रारंभ स्थान',
    fromLabel: 'से',
    datVisitorPass: 'दिन विज़िटर पास',
    tapToHide: 'छिपाने के लिए टैप करें',
    tapToShow: 'गेट पर QR कोड दिखाने के लिए टैप करें',
    getMyQR: 'मेरा QR प्राप्त करें',
    getMyQRSubtitle: 'अपना विज़िटर पास पाने के लिए पंजीकरण करें',
    getPassFirst: 'कृपया पहले अपना पास प्राप्त करें',
    quickLinks: [
      { id: 'meals', label: 'भोजन' },
      { id: 'buggy', label: 'बग्गी' },
      { id: 'explore', label: 'एक्सप्लोर करें' },
      { id: 'nearby', label: 'आस-पास' },
      { id: 'tours', label: 'टूर' },
      { id: 'plan', label: 'अपनी यात्रा की योजना बनाएं' },
    ],
    quotes: {
      text: 'एक बच्चे की तरह खेलो, हँसो और सोओ। सांसारिक उपलब्धियों को अपनी स्वाभाविक मासूमियत की कीमत पर हासिल न होने दो।',
      source: 'पूज्य गुरुदेवश्री राकेशजी',
    },
    planYourVisit: {
      first: 'अपनी यात्रा की',
      second: 'योजना बनाएं',
    },
    whenAreYouArriving: 'आप कब आ रहे हैं?',
    selectedLabel: 'चयनित',
    howLong: 'कितने समय के लिए?',
    showThisAtTheGate: 'इसे प्रवेश द्वार पर दिखाएँ',
    swipeToSwitchPass: 'पास बदलने के लिए स्वाइप करें',
    createMyTour: 'मेरा टूर बनाएं',
    yourTour: 'आपका टूर',
    yourRecommendedTour: 'सुझाया गया टूर',
    overnightLabel: 'रात भर',
    extraSuggestionTitle: 'अपनी यात्रा बढ़ाएं',
    waitLabel: 'प्रतीक्षा',
    checkinFrom: 'चेक-इन',
    checkoutBy: 'चेक-आउट',
    thisEvening: 'आज शाम',
    tomorrowMorning: 'कल सुबह',
    bookStayTitle: 'आश्रम में ठहरने की बुकिंग करें',
    bookStayCta: 'बुक करें',
    planAnotherVisit: 'फिर से आयोजन करें',
    downloadPdf: 'PDF डाउनलोड करें',
    printPdf: 'प्रिंट',
    welcomeCentre: 'स्वागत केंद्र',
    welcomeCentreOrientation: 'स्वागत केंद्र परिचय',
    atWelcomeCentre: 'स्वागत केंद्र पर',
    ashramTour: 'आश्रम टूर',
    partOfAshramTour: (desc) => `आश्रम टूर का हिस्सा - ${desc}`,
    walkOrBuggy: (min) => `${min} मिनट पैदल या बग्गी`,
    diningHall: 'डाइनिंग हॉल / कैफेटेरिया',
    duringMealTime: 'भोजन समय के दौरान',
    seeLabel: 'देखें:',
    aartiAtJinmandir: (time) => `जिनमंदिर में आरती · ${time}`,
    tourLabel: 'टूर',
    guidedToursTitle: 'गाइड के साथ आश्रम दर्शन',
    guidedToursSubtitle: 'स्वागत केंद्र से 45 मिनट',
    guidedTourArrivalNote: 'कृपया अपनी गाइडेड टूर शुरू होने से 15 मिनट पहले पहुँच जाएँ। यदि आपकी टूर 9:00 AM पर शुरू होती है, तो ओरिएंटेशन के लिए 8:45 AM तक पहुँच जाएँ।',
    duration45: '45 मिनट',
    stopsLabel: 'स्टॉप्स',
    freeTimeRemaining: (min) => `~${min} मिनट खाली समय शेष`,
    placesExploreInfo: [
      { title: 'आश्रम की समय सारणी', subtitle: 'दैनिक समय', dark: true, icon: 'calendar', href: 'https://www.srmd.org/AshramDailySchedule/?type=V' },
      
      { title: 'आश्रम की संस्कृति', subtitle: 'मूल्य और जीवन शैली', dark: false, icon: 'people', href: '/ashram-culture' },
       { title: 'उपयोगी जानकारी', subtitle: 'उपयोगी लिंक', dark: false, icon: 'info' },
     
    ],
    relatedInfo: {
      title: 'सहायता और जानकारी',
      loading: 'लोड हो रहा है…',
      error: 'अभी जानकारी लोड नहीं हो पा रही है।',
      searchPlaceholder: 'खोजें',
      close: 'बंद करें',
    },
    scheduleLabels: {
      Breakfast: 'नाश्ता',
      'Ashram Tour': 'आश्रम टूर',
      Pravachan: 'प्रवचन',
      Lunch: 'दोपहर का भोजन',
      Satsang: 'सत्संग',
      Aarti: 'आरती',
      Dinner: 'रात का भोजन',
    },
    eveningYogaText: 'योग 5:15 PM – 5:45 PM · यज्ञस्थल',
    aartiJinmandirTime: '7:30 PM – 8:00 PM',
    mealDayPass: { key: 'dayPass', name: 'डे पास', desc: 'सभी भोजन (नाश्ता, दोपहर, रात)', price: 330 },
    foodAndDining: 'भोजन',
    cafeteriaAvailabilityNote: 'कैफेटेरिया भी मुलाक़ातीों के लिए उपलब्ध है और सुबह 8 बजे से सूर्यास्त तक खुला रहता है।',
   
    gettingAround: 'सुविधापूर्ण यात्रा के लिए',
    nextBuggy: 'वेलकम सेंटर से बग्गी',
    buyMealCoupon: 'भोजन कूपन खरीदें',
    clickToBuyMeal: 'भोजन खरीदने के लिए क्लिक करें',
    buggyFinder: 'बग्गी फाइंडर',
    buyEpass: 'बग्गी कूपन खरीदें',
    buyMealPass: 'भोजन पास खरीदें',
    whereAreYouNow: 'आप अभी कहाँ हैं?',
    upcomingTimings: 'आगामी समय',
    viewFullSchedule: 'पूरा शेड्यूल देखें',
    viewRoute: 'रूट देखें',
    routeStopsLabel: 'रूट स्टॉप्स',
    fullScheduleLabel: 'आगामी राइड्स',
    rideNoLabel: 'राइड नं.',
    noBuggyRoutes: 'इस स्टॉप के लिए कोई बग्गी रूट नहीं मिला।',
    nearbyPlacesTitle: 'आसपास के अवश्य देखने योग्य स्थल',
    fullScheduleTitle: 'पूरा शेड्यूल',
    morning: 'सुबह',
    afternoon: 'दोपहर',
    evening: 'शाम',
    noScheduleAvailable: 'कोई शेड्यूल उपलब्ध नहीं है।',
    walkingDistancesTitle: 'पैदल दूरी',
    toLabel: 'तक',
    distanceLabel: 'दूरी',
    timeLabel: 'समय',
    minsShort: 'मिनट',
    noWalkingData: 'कोई पैदल दूरी उपलब्ध नहीं है।',
    venueLabel: 'स्थान',
    myCoupen: 'मेरा ट्रान्सेक्शन',
    every15Minutes: 'हर 15 मिनट में',
    buggyStops: [
      'वेलकम सेंटर',
      'यज्ञस्थल - 2',
      'राज दरबार',
      'लोअर डाइनिंग',
      'जिन मंदिर',
      'कम्युनिटी गार्डन',
      'साधना - आराधना',
      'अपर डाइनिंग',
      'श्रद्धा',
      'यज्ञस्थल - 3',
      'वेलकम सेंटर'
    ],
    buyBuggyCoupon: 'बग्गी कूपन ख़रीदे',
    routeMap: 'रूट मैप',
    spaces: [
      { name: 'जिनमंदिर', img: 'https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2022/02/JM-Pg_Top-Banner-2.jpg?x83243', desc: 'पवित्र जैन मंदिर', featured: true },
      { name: 'राज सभागृह', img: 'https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2023/12/RS_Nightime.jpg', desc: 'स्व-अध्ययन और चिंतन' },
      { name: 'राज दरबार', img: 'https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2022/12/Raj_Darbar-1-new.png', desc: 'भव्य दरबार' },
      { name: 'ध्यान कक्ष', img: 'https://images.unsplash.com/photo-1545389336-cf090694435e?w=400&q=80', desc: 'शांत ध्यान' },
      { name: 'पुस्तकालय', img: 'https://images.unsplash.com/photo-1526243741027-444d633d7365?w=300&q=80', desc: 'किताबें और शांत अध्ययन' },
      { name: 'ध्यान उद्यान', img: 'https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?w=400&q=80', desc: 'प्रकृति में सैर' },
      { name: 'दिव्य दुकान', img: 'https://images.unsplash.com/photo-1526243741027-444d633d7365?w=300&q=80', desc: 'साहित्य और उपहार' },
    ],
    placesNearby: [
      { name: 'राज उपहार', img: 'https://upload.wikimedia.org/wikipedia/commons/9/99/Shrimad_Rajchandra_Mission_Dharampur_Yatra.jpg' },
      { name: 'श्रीमद राजचंद्र जीवमैत्रीधाम', img: 'https://upload.wikimedia.org/wikipedia/commons/3/3c/Shrimad_Rajchandra_Mission_Dharampur_Ashram.jpg' },
      { name: 'लेडी विल्सन संग्रहालय', img: 'https://upload.wikimedia.org/wikipedia/commons/6/6f/Lakshmi_Temple_Dharampur.jpg' },
      { name: 'रंचोड़भाई हाउस', img: 'https://upload.wikimedia.org/wikipedia/commons/6/69/View_of_dharampur.jpg' },
    ],
    RECOMMENDED: 'हमारा सुझाव',
    yourCompanion: 'आंतरिक विकास और दैनिक आध्यात्मिक अभ्यास के लिए एक निःशुल्क मोबाइल ऐप',
    exploreSpace: {
      first: 'दर्शनीय',
      second: 'स्थल',
    },
    nearbySpace: {
      first: 'आसपास के',
      second: 'दर्शनीय स्थल',
    },
    selfConnect: 'सेल्फ कनेक्ट',
    appStore: 'ऐप स्टोर',
    playStore: 'प्ले स्टोर',
    mealCouponTitle: 'भोजन कूपन',
    mealCouponDesc: 'आश्रम में भोजन के लिए कूपन खरीदें।',
    forDayVisitors: 'दिनभर के लिए',
    orBuyIndividualMeals: 'या अलग भोजन खरीदें',
    subtotal: 'सब-टोटल',
    payOnline: 'ऑनलाइन पेमेंट करें',
    processing: 'आयोजन हो रहा है…',
    mealCouponNote: 'कृपया ध्यान दें: आप भोजन पास रजिस्ट्रेशन ऑफिस से भी खरीद सकते हैं।',
    noMealsAvailable: 'इस समय भोजन उपलब्ध नहीं है',
    transactionHistoryTitle: 'ट्रांजेक्शन हिस्ट्री',
    transactionHistorySubtitle: 'आपके भोजन और बग्गी कूपन की खरीद.',
    back: 'पीछे',
    filterAll: 'सभी',
    filterMeals: 'भोजन',
    filterBuggy: 'बग्गी',
    loadingTransactions: 'ट्रांजेक्शन लोड हो रहे हैं…',
    noTransactions: 'इस श्रेणी में कोई ट्रांजेक्शन नहीं है।',
    amountPaid: 'भुगतान की गई राशि',
    mealCouponsLabel: 'भोजन कूपन',
    buggyCouponsLabel: 'बग्गी कूपन',
    scanningHistoryTitle: 'स्कैनिंग हिस्ट्री',
    loadingScans: 'स्कैन लोड हो रहे हैं…',
    noScanningHistory: 'कोई स्कैनिंग हिस्ट्री नहीं मिली।',
    buggyCouponTitle: 'बग्गी कूपन',
    buggyCouponDesc: 'आश्रम 223 एकड़ की विशाल भूमि में फैला है, इसलिए आसान आवागमन के लिए बग्गी पास खरीदने की सलाह दी जाती है।',
    dailyPass: 'दैनिक पास',
    buggyCouponNote: 'कृपया ध्यान दें: आप बग्गी पास रजिस्ट्रेशन ऑफिस से भी खरीद सकते हैं।',
    overnightLabelKey: 'रात भर',
    plannerActivities: {
      jinmandir: { name: 'जिनमंदिर', desc: 'पवित्र जैन मंदिर', whatToSee: 'श्री महावीर प्रसाद और गुरुमंदिर' },
      swadhyay: { name: 'राज सभागृह', desc: 'स्व-अध्ययन हॉल', whatToSee: 'स्वाध्याय हॉल, ध्यान हॉल और पुस्तकालय' },
      rajdarbar: { name: 'राज दरबार', desc: 'भव्य दरबार' },
      library: { name: 'पुस्तकालय', desc: 'किताबें और शांत अध्ययन' },
      meditation: { name: 'ध्यान कक्ष', desc: 'शांत ध्यान स्थान' },
      gardens: { name: 'ध्यान उद्यान', desc: 'शांतिपूर्ण पथ' },
      cafeteria: { name: 'कैफेटेरिया', desc: 'हल्का भोजन और रिफ्रेशमेंट' },
      bookstore: { name: 'दिव्य दुकान', desc: 'साहित्य और स्मृति चिह्न' },
      aarti: { name: 'आरती दर्शन', desc: 'पवित्र प्रार्थना समारोह' },
    },
  },
}

export const entryI18n = {
  en: {
    title: 'Ashram Day Visit Entry',
    titleTag: 'Welcome to the Ashram',
    titleLine1: 'Ashram Day Visit',
    titleLine2: '',
    subtitle: 'Kindly fill this form on the day of your visit',
    visitDetails: 'Visit Details',
    dateLabel: 'Date of Visit',
    cityLabel: 'City',
    cityPlaceholder: 'Enter your city',
    visitors: 'No. of Visitors',
    visitorDetails: 'Visitor Details',
    visitor: 'Visitor',
    mobile: 'Mobile Number',
    fullName: 'Full Name',
    gender: 'Gender',
    age: 'Age',
    ageValue: (value) => `Age ${value}`,
    male: 'Male',
    female: 'Female',
    other: 'Other',
    addVisitor: 'Add Another Visitor',
    removeVisitor: 'Remove',
    cta: 'Generate Entry Pass',
    ctaContinue: 'Continue',
    successTitle: 'Your entry is confirmed',
    successSubtitle: 'Show this pass at the gate. Jai Gurudev!',
    successBtn: 'Done',
    required: 'This field is required',
    nameMustBeUnique: 'Full Name should be unique',
    PhnMustBeUnique: 'Mobile Number should be unique',
    mobileInvalid: 'Please enter a valid 10-digit mobile number',
    mobileAtLeastOne: 'Please enter at least one mobile number',
    entryPass: 'Entry Pass',
    memberFound: 'Member Found',
    successToastPrefix: 'Success:',
    errorToastPrefix: 'Error:',
  },
  gu: {
    title: 'આશ્રમ દિવસ મુલાકાત પ્રવેશ',
    titleTag: 'આશ્રમમાં આપનું સ્વાગત છે',
    titleLine1: 'આશ્રમ ની મુલાકાત',
    titleLine2: '',
    subtitle: 'કૃપા કરીને નીચે ની વિગતો ભરો',
    visitDetails: 'મુલાકાતની વિગતો',
    dateLabel: 'મુલાકાતની તારીખ',
    cityLabel: 'શહેર',
    cityPlaceholder: 'તમારું શહેર લખો',
    visitors: 'મુલાકાતીઓ ની સંખ્યા',
    visitorDetails: 'મુલાકાતી વિગતો',
    visitor: 'મુલાકાતી',
    mobile: 'મોબાઇલ નંબર',
    fullName: 'પૂરું નામ',
    gender: 'જાતિ',
    age: 'ઉંમર',
    ageValue: (value) => `ઉંમર ${value}`,
    male: 'પુરુષ',
    female: 'સ્ત્રી',
    other: 'અન્ય',
    addVisitor: 'બીજા મુલાકાતી ઉમેરો',
    removeVisitor: 'દૂર કરો',
    cta: 'એન્ટ્રી પાસ બનાવો',
    ctaContinue: 'ચાલુ રાખો',
    successTitle: 'તમારી એન્ટ્રી કન્ફર્મ છે',
    successSubtitle: 'ગેટ પર આ પાસ બતાવો. જય ગુરુદેવ!',
    successBtn: 'થઈ ગયું',
    required: 'આ ફીલ્ડ જરૂરી છે',
    nameMustBeUnique: 'પૂરું નામ અનન્ય હોવું જોઈએ',
    PhnMustBeUnique: 'મોબાઇલ નંબર અનન્ય હોવું જોઈએ',
    mobileInvalid: 'કૃપા કરીને માન્ય 10 અંકનો મોબાઇલ નંબર દાખલ કરો',
    mobileAtLeastOne: 'કૃપા કરીને ઓછામાં ઓછો એક મોબાઇલ નંબર દાખલ કરો',
    entryPass: 'એન્ટ્રી પાસ',
    memberFound: 'સભ્ય મળ્યો',
    successToastPrefix: 'સફળતા:',
    errorToastPrefix: 'ભૂલ:',
  },
  hi: {
    title: 'आश्रम दिवस भ्रमण प्रवेश',
    titleTag: 'आश्रम में आपका स्वागत है',
    titleLine1: 'आश्रम भ्रमण',
    titleLine2: '',
    subtitle: 'कृपया नीचे अपना विवरण भरें',
    visitDetails: 'भ्रमण विवरण',
    dateLabel: 'भ्रमण की तारीख',
    cityLabel: 'शहर',
    cityPlaceholder: 'अपना शहर लिखें',
    visitors: 'मुलाक़ाती की संख्या',
    visitorDetails: 'मुलाक़ाती विवरण',
    visitor: 'मुलाक़ाती',
    mobile: 'मोबाइल नंबर',
    fullName: 'पूरा नाम',
    gender: 'जाति',
    age: 'उम्र',
    ageValue: (value) => `उम्र ${value}`,
    male: 'पुरुष',
    female: 'महिला',
    other: 'अन्य',
    addVisitor: 'एक और मुलाक़ाती जोड़ें',
    removeVisitor: 'हटाएँ',
    cta: 'एंट्री पास बनाएं',
    ctaContinue: 'जारी रखें',
    successTitle: 'आपकी एंट्री कन्फर्म है',
    successSubtitle: 'गेट पर यह पास दिखाएं। जय गुरुदेव!',
    successBtn: 'हो गया',
    required: 'यह फील्ड आवश्यक है',
    nameMustBeUnique: 'पूरा नाम अनोखा होना चाहिए',
    PhnMustBeUnique: 'मोबाइल नंबर अनोखा होना चाहिए',
    mobileInvalid: 'कृपया मान्य 10 अंकों का मोबाइल नंबर दर्ज करें',
    mobileAtLeastOne: 'कृपया कम से कम एक मोबाइल नंबर दर्ज करें',
    entryPass: 'एंट्री पास',
    memberFound: 'सदस्य मिला',
    successToastPrefix: 'सफलता:',
    errorToastPrefix: 'त्रुटि:',
  },
}